// import {
//     Tabs,
//     TabsHeader,
//     TabsBody,
//     Tab,
//     TabPanel,
// } from "@material-tailwind/react";
import dayjs from 'dayjs';
// import 'moment/locale/th'

import React, { useEffect, useState } from "react";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EPWeekPicker from "./EPWeekPicker";
// import { SettingContext } from "../App";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch } from "react-redux";
import { IconButton, Typography } from "@mui/material";
import { setWeekOfYear } from '../../reducer/weekOfYearSlice';
import { setMonitorTimelineWeek } from '../../reducer/monitorPageSlice';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
// import { setEndWeek, setStartWeek, setWeekOfYear } from "../../reducer/weekOfYearSlice";

// import { differenceInDays, subDays, addDays } from 'date-fns';

dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
// dayjs.locale("th");
// dayjs.extend(buddhistEra);

export default function TimeRangeSetting(props) {
    const { skipMode } = props
    const dispatch = useDispatch();

    const [weekSelected, setWeekSelected] = useState();

    useEffect(() => {
        let currentDate = dayjs();
        currentDate = currentDate.add((currentDate.day() * -1), 'days');
        setWeekSelected(currentDate);
        const weekOfYearEnd = calWeekOfYear(currentDate);

        let weekList = [];
        const current = dayjs(weekOfYearEnd.from);
        for (let index = 0; index < 52; index++) {
            const date = current.add((51 - index) * -1, "week");
            const woy = calWeekOfYear(date);
            weekList.push(woy);
        }
        dispatch(setMonitorTimelineWeek(weekList));

        dispatch(setWeekOfYear(weekOfYearEnd));

    }, [dispatch])

    const calWeekOfYear = (date) => {
        const weekYear = date.format('YYYY-ww');
        const year = parseInt(weekYear.split('-')[0]);
        const week = parseInt(weekYear.split('-')[1]);

        const startDateWOY = date.add(date.$W * -1, "day");
        const startDateWeek = dayjs(startDateWOY.valueOf()).hour(0).minute(0).second(0).millisecond(0);

        const endDateWOY = date.add(6 - date.$W, "day");
        const endDateWeek = dayjs(endDateWOY.valueOf()).hour(23).minute(59).second(59).millisecond(999);

        return {
            week: week,
            year: year,
            // from: startDateWeek.valueOf(),
            // to: endDateWeek.valueOf()
            from: startDateWeek.format('YYYY-MM-DD'),
            to: endDateWeek.format('YYYY-MM-DD')
        }
    }
    // }

    const handleWeekSelected = (newValue) => {
        if (weekSelected.format('YYYY-ww') !== newValue.format('YYYY-ww')) {
            setWeekSelected(newValue.add(newValue.$W * -1, "day"));
            const weekOfYear = calWeekOfYear(newValue);
            dispatch(setWeekOfYear(weekOfYear));
        }
    }

    const handlePreviousWeek = () => {
        const newValue = weekSelected.add(-7, "day")
        setWeekSelected(newValue);
        const weekOfYear = calWeekOfYear(newValue);
        dispatch(setWeekOfYear(weekOfYear));
    }

    const handleNextWeek = () => {
        const newValue = weekSelected.add(7, "day")
        setWeekSelected(newValue);
        const weekOfYear = calWeekOfYear(newValue);
        dispatch(setWeekOfYear(weekOfYear));
    }

    return (
        <div className='w-full flex flex-col gap-2'>
            <div className='flex flex-row items-center px-2'>
                {skipMode && (
                    <IconButton aria-label="previous" className='text-[#cd6c4a]' onClick={handlePreviousWeek}>
                        <SkipPreviousIcon />
                    </IconButton>
                )}
                {weekSelected && (
                    <EPWeekPicker
                        className="w-full mx-2"
                        format="ww/YYYY"
                        label="เลือกสัปดาห์"
                        maxDate={dayjs().day(6)}
                        onChange={handleWeekSelected}
                        value={weekSelected} />
                )}
                {skipMode && (
                    <IconButton aria-label="previous" className='text-[#cd6c4a]' onClick={handleNextWeek} disabled={weekSelected >= dayjs().day(0).hour(0).minute(0).second(0)}>
                        <SkipNextIcon />
                    </IconButton>
                )}
            </div>
            {weekSelected && (
            <div className='mx-5 py-1 text-center font-primary text-sm'>* ประเมินจากสัปดาห์ที่ {calWeekOfYear(weekSelected.add(-4, "week")).week} - {calWeekOfYear(weekSelected.add(-1, "week")).week}</div>
            )}
        </div>

    );
}
